// extracted by mini-css-extract-plugin
export default {"channels":"channels__1V-35"};